
import React from 'react';
import { Row, Col, Tooltip } from "antd";
import { useTranslation } from 'react-i18next';
import CardDSPScreensHolder from './Styles/cardDSPScreensStyle';
import { getTotalDisplays, getTotalCircuitsDisplays, getTotalCircuits, getTotalIndividualDisplays, getTotalMultipleFacesDisplays, getTotalMultipleFaces, getTotalMultipleFacesInCircuits, getTotalDisplaysWithMultipleFacesInCircuits } from '../services/cart';
import DisplaysDetailList from './customComponents/DisplaysDetailList/DisplaysDetailList';


const CardDSPScreensComponent = (props) => {
  const { t } = useTranslation();
  const { stepsCurrent, cart, programmatic, dsp, is_guaranteed, isGuaranteed } = props;
  const detailsDisplays = {
    totalDisplays: getTotalDisplays(cart),
    totalCircuitsDisplays: getTotalCircuitsDisplays(cart),
    totalCircuits: getTotalCircuits(cart),
    totalIndividualDisplays: getTotalIndividualDisplays(cart),
    totalMultipleFacesDisplays: getTotalMultipleFacesDisplays(cart),
    totalDisplaysWithMultipleFacesInCircuits: getTotalDisplaysWithMultipleFacesInCircuits(cart),
    totalMultipleFacesInCircuits: getTotalMultipleFacesInCircuits(cart),
    totalMultipleFaces: getTotalMultipleFaces(cart)
  }
  let campaignTypeText = t("Traditional");
  if (programmatic === 'programmatic') {
  campaignTypeText =
    is_guaranteed || isGuaranteed
      ? t("Programmatic PG")
      : t("Programmatic PMP");
}

  return (
    <CardDSPScreensHolder hasRedistribute={programmatic === "programmatic" && stepsCurrent > 1}>
      <div className="cardGeneral">
        <Row justify="center">
          <Col span={24}>
            <div className='infoDate'>{t("DSP")}</div>
            <div className='brandClientNameContainer'>
              <p className='brandClientName'>{ (dsp && dsp.name) || "Latinad" }</p>
            </div>

            <div className='infoDate'>{t("Exchange")}</div>
            <div className='brandClientNameContainer'>
              <p className='brandClientName'>{ (dsp && dsp.exchange) || "Latinad" }</p>
            </div>

            <div className='infoDate'>{t("Tipo de campaña")}</div>
            <div className='brandClientNameContainer'>
              <p className='brandClientName'>{ campaignTypeText }</p>
            </div>
          </Col>
        </Row>
      </div>

      <div className="cardGeneral">
        <Row justify="center">
          <Col span={24}>
            <div className='infoDate'>{t("Cantidad de pantallas")}</div>
            <div className='brandClientNameContainer'>
              <Tooltip title={
                <DisplaysDetailList detailsDisplays={detailsDisplays} icons={true} />
              }>
                <p className='brandClientName'>{detailsDisplays.totalDisplays}</p>
              </Tooltip>
            </div>
          </Col>
        </Row>
      </div>
    </CardDSPScreensHolder>
  );
};

export default CardDSPScreensComponent;